import React from "react";
import Broadcasthead from "./Broadcasthead";
import Broadcastlist from "./Broadcastlist";

const MainBroadcast = () => {
  return (
    <div>
      <Broadcasthead />
      <Broadcastlist />
    </div>
  );
};

export default MainBroadcast;
